import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { Toaster } from 'app/shared/lib/toaster';
import { apiCall } from 'app/shared/lib/essette-api';
import { MemberService } from 'app/cd/services/member-service';
import * as CD from 'app/cd/models/essette-api';


@autoinject()
export class SaveMemberProviderRelationship extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ defaultBindingMode: bindingMode.toView })
    protected relationship: CD.MemberProviderRelationship | null = null;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: MemberService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    public reset(): void {
        this.relationship = null;
    }

    public async submit(): Promise<boolean> {
        return this.saveRelationship();
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async saveRelationship(): Promise<boolean> {
        if(!this.relationship) return false;

        let isSuccessful = false;
        try {
            this.state.beginSave();

            const response = await this.service.saveMemberProviderRelationship(this.relationship);
            isSuccessful = response.isSuccessful;
            return isSuccessful;
        } catch(error) {
            throw error;
        } finally {
            this.toaster.standard.saved('cd:memberProviderRelationship.$', isSuccessful);
            this.state.endSave();
        }

    }
}
